module.exports = __webpack_public_path__ + "img/StorageSpaces.35ac54a5.svg";